import {
  Bell,
  Bot,
  CalendarDays,
  Landmark,
  LayoutDashboard,
  Newspaper,
  RefreshCw,
  Settings,
  SlidersHorizontal,
  TrendingUp,
  type LucideIcon,
} from "../icon-bank/AnimatedIcons";
import type { TourIconKey } from "./tour-content";

export const TOUR_ICON_MAP: Record<TourIconKey, LucideIcon> = {
  desk: LayoutDashboard,
  consilium: Landmark,
  scouts: Bot,
  riskflow: Newspaper,
  calendar: CalendarDays,
  performance: TrendingUp,
  settings: Settings,
  notifications: Bell,
  toolbar: SlidersHorizontal,
  loop: RefreshCw,
};

export function TourStepIcon({
  name,
  className,
}: {
  name: TourIconKey;
  className?: string;
}) {
  const Icon = TOUR_ICON_MAP[name];
  return <Icon aria-hidden="true" className={className} />;
}
